import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { required } from 'helpers/validators';
import FormActionResponsiveButtons from 'components/FormActionButtons/FormActionResponsiveButtons';
import { Field } from 'components/Forms';
import GenericInput from 'components/GenericInput/GenericInput';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';
import { MaxWidthWrapper } from 'components/Wrappers';

import { Fields, StepProps } from '../../types';

const StepLastName: FC<StepProps> = () => (
  <>
    <GenericTitle isMedium marginBottom={TitleMargin.Lg}>
      <FormattedMessage id="onboarding.stepLastName.title" tagName="span" />
    </GenericTitle>

    <MaxWidthWrapper>
      <Field
        name={Fields.LastName}
        validate={required}
        renderControl={({ input, meta }) => (
          <GenericInput
            {...input}
            placeholder="onboarding.stepLastName.placeholder"
            hasError={meta.showError}
            hasNoBackground
            hasFullWidth
            autoFocus
          />
        )}
      />
    </MaxWidthWrapper>

    <FormActionResponsiveButtons hasUnderline />
  </>
);

export default StepLastName;
